import React, { useContext, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthContext, AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import Navbar from './components/Navbar';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Courses from './pages/Courses';
import CourseDetail from './pages/CourseDetail';
import AllVideos from './pages/AllVideos';
import CreateCourse from './pages/CreateCourse';
import Certificates from './pages/Certificates';
import Diagnostics from './pages/Diagnostics';
import ViewAllVideos from './pages/ViewAllVideos';
import StudentVideos from './pages/StudentVideos';
import StudentLabs from './pages/StudentLabs';
import TakeLab from './pages/TakeLab';
import ViewAllTutorials from './pages/ViewAllTutorials';
import Forum from './pages/Forum';
import Attendance from './pages/Attendance';
import InstructorDashboard from './pages/InstructorDashboard';
import ManageVideos from './pages/ManageVideos';
import ViewUnitVideos from './pages/ViewUnitVideos';
import ManageLabs from './pages/ManageLabs';
import ManageTutorials from './pages/ManageTutorials';
import ManageAttendance from './pages/ManageAttendance';
import TrackGLA from './pages/TrackGLA';
import './styles/global.css';
import './styles/components.css';
import './styles/layout.css';
import './styles/pages.css';
import './styles/landing.css';
import ForumDetail from './pages/ForumDetail';



const DashboardRoute = () => {
  const { user, token, loading } = useContext(AuthContext);
  
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#ffffff' }}>
        <p style={{ fontSize: '1.1rem', color: '#666' }}>Loading...</p>
      </div>
    );
  }
  
  if (!token) {
    return <Navigate to="/login" />;
  }
  
  // Redirect instructors and admins to instructor dashboard
  if (user?.role === 'instructor' || user?.role === 'admin') {
    return <InstructorDashboard />;
  }
  
  // Students go to regular dashboard
  return <Dashboard />;
};

const App = () => {
  useEffect(() => {
    // Hide the loading screen once the app mounts
    const loadingScreen = document.querySelector('.app-loading');
    if (loadingScreen) {
      loadingScreen.style.display = 'none';
    }
  }, []);

  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: '#ffffff' }}>
            <Navbar />
            <div style={{ flex: 1, background: '#ffffff' }}>
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/forums/:id" element={<ForumDetail />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/diagnostics" element={<Diagnostics />} />
                <Route path="/dashboard" element={<DashboardRoute />} />
                <Route path="/courses" element={<Courses />} />
                <Route path="/course/:id" element={<CourseDetail />} />
                <Route path="/course/:id/videos" element={<AllVideos />} />
                <Route path="/course/:id/all-videos" element={<ViewAllVideos />} />
                <Route path="/course/:id/student-videos" element={<StudentVideos />} />
                <Route path="/course/:id/all-labs" element={<StudentLabs />} />
                <Route path="/take-lab/:labId" element={<TakeLab />} />
                <Route path="/course/:id/all-tutorials" element={<ViewAllTutorials />} />
                <Route path="/create-course" element={<CreateCourse />} />
                <Route path="/certificates" element={<Certificates />} />
                <Route path="/forums" element={<Forum />} />
                {/* <Route path="/forum/:id" element={<ForumThread />} /> */}
                <Route path="/attendance" element={<Attendance />} />
                <Route path="/manage-videos" element={<ManageVideos />} />
                <Route path="/manage-videos/unit/:unit" element={<ViewUnitVideos />} />
                <Route path="/manage-labs" element={<ManageLabs />} />
                <Route path="/manage-tutorials" element={<ManageTutorials />} />
                <Route path="/manage-attendance" element={<ManageAttendance />} />
                <Route path="/track-gla" element={<TrackGLA />} />
              </Routes>
            </div>
            <footer className="footer">
              GRIT Lab Africa &copy; 2026 All rights reserved.
            </footer>
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
